import { Icon } from "@/components/icons";
import { STATUS_BADGE, STATUS_ICON, STATUS_LABELS } from "@/components/match-decision-panel";
import type { MatchDecisionStatus } from "@/app/(app)/screening/_data/types";

type MatchStatusTagProps = {
  status: MatchDecisionStatus;
};

/**
 * Status pill for a match decision — "New Match", "Real Match",
 * "False Match". Uses the canonical STATUS_BADGE tones (yellow / green /
 * red) and STATUS_ICON glyphs shared with the match decision panel and the
 * match-detail title bar. Geometry matches Tag size="sm" (24px height, 8px
 * side padding, 6px gap).
 */
export function MatchStatusTag({ status }: MatchStatusTagProps) {
  return (
    <span
      className={[
        "inline-flex h-6 shrink-0 items-center gap-1.5 rounded-[4px] px-2 text-small font-medium whitespace-nowrap",
        STATUS_BADGE[status],
      ].join(" ")}
    >
      <Icon name={STATUS_ICON[status]} size={20} />
      <span>{STATUS_LABELS[status]}</span>
    </span>
  );
}
